/**
 * Directive: modal
 */
angular.module('acme.common.directive.modal', [
  'acme.common.directive.fieldFocus'
])
.directive('modal', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/modal/modal.tpl.html',
      scope: {
        errors: '=',
        messages: '=',
        done: '&',
        cancel: '&',
        title: '@',
        saveText: '@',
        cancelText: '@',
        left: '@',
        leftAction: '&',
        leftActionLabel: '@',
        leftClass: '@',
        right: '@',
        rightAction: '&',
        rightActionLabel: '@',
        rightClass: '@',
        hideActions: '@',
        hideDone: '=',
        doneFocus: '@',
        showCancel: '@',
        footerText: '@',
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.modal = {

          isSubmitted: false,
          saveText: 'Save',
          cancelText: 'Cancel',
          showCancel: true,

          init: function() {
            this.showCancel = $scope.showCancel || true;
            this.saveText = $scope.saveText || 'Save';
            this.cancelText = $scope.cancelText || 'Cancel';
          },

          hasErrors: function() {
            return ($scope.errors instanceof Array && $scope.errors.length > 0);
          },

          hasMessages: function() {
            return ($scope.messages instanceof Array && $scope.messages.length > 0);
          },

          done: function() {
            this.isSubmitted = true;
            $scope.done();
          },

          cancel: function() {
            $scope.cancel();
          }

        };

        $scope.modal.init();

      }]

    };

}]);